import {getApi} from '../../modules/common/utils/api'

const api = getApi('audit')

export function createAudit(auditData) {
  return api.post(`/api/v1/audits`, {audit: auditData})
}

export function getAudit(id, params = {}) {
  return api.post(`/api/v1/audits/show_audit`, {
    ...params,
    id: id,
  })
}

export function getAuditItems(id, params = {}) {
  return api.get(`/api/v1/audit_entity_objects/${id}`, {
    params: params,
  })
}

export function getAssignedTo(id, params = {}) {
  return api.get(`/api/v1/audits/assigned_info?id=${id}`, {
    params: params,
  })
}

export function getItemsHistory({auditid, entityid, itemid}) {
  return api.get(
    `/api/v1/audits/audit_entities/item_history?audit_id=${auditid}&audit_entity_id=${entityid}&entity_object_id=${itemid}`
  )
}

export function getAudits(params = {}) {
  return api.get(`/api/v1/audits`, {
    params: params,
  })
}

export function getAuditItemsCount(params = {}) {
  return api.post(`/api/v1/total_and_scanned_items_count`, {
    audit_ids: params,
  })
}

export function updateAudit(id, auditData) {
  return api.put(`/api/v1/audits?id=${id}`, {audit: auditData})
}

export function closeIndividualAudit(id, auditData) {
  return api.post(`/api/v1/audits/${id}/audit_users`, {audit_user: auditData})
}
export function deleteAudit(id) {
  return api.delete(`/api/v1/audits?id=${id}`)
}
